export default "__VITE_ASSET__DWsiLrOl__"